export default "__VITE_ASSET__b4DQBz5u__"